import type { ManageProfileSopSection } from "../types";

export const MANAGE_PROFILE_SOP_SECTIONS: ManageProfileSopSection[] = [
  {
    id: "before-you-start",
    titleKey: "manage-profile-sop-before-start-title",
    titleFallback: "Before you start",
    introKey: "manage-profile-sop-before-start-intro",
    introFallback:
      "Your profile is your personal account in Kivunova FMS. Keep your name, phone, and photo up to date so your team can reach you and you can recover access if needed.",
    steps: [
      {
        bodyKey: "manage-profile-sop-before-start-1",
        bodyFallback:
          "Any signed-in user can open and update their own profile. You are editing your personal details, not company or store settings."
      },
      {
        bodyKey: "manage-profile-sop-before-start-2",
        bodyFallback: "Sign in first. Then open Profile from the left menu."
      },
      {
        bodyKey: "manage-profile-sop-before-start-3",
        bodyFallback:
          "Use the Profile tab for contact details and photo. Use the Password tab when you need to change your login password."
      }
    ]
  },
  {
    id: "open-profile",
    titleKey: "manage-profile-sop-open-title",
    titleFallback: "Open your profile",
    introKey: "manage-profile-sop-open-intro",
    introFallback:
      "The Profile page is where you review your account details and sign out when you are done for the day.",
    steps: [
      {
        bodyKey: "manage-profile-sop-open-1",
        bodyFallback: "After you sign in, open Profile from the left menu."
      },
      {
        bodyKey: "manage-profile-sop-open-2",
        bodyFallback: "You will see two tabs at the top: Profile and Password."
      },
      {
        bodyKey: "manage-profile-sop-open-3",
        bodyFallback:
          "The Profile tab shows your photo, role, contact details, and account status.",
        imageId: "profile-view"
      }
    ]
  },
  {
    id: "view-details",
    titleKey: "manage-profile-sop-view-title",
    titleFallback: "View your details",
    introKey: "manage-profile-sop-view-intro",
    introFallback:
      "Check this page when you want to confirm the email or phone linked to your account before sharing details with a customer or colleague.",
    steps: [
      {
        bodyKey: "manage-profile-sop-view-1",
        bodyFallback:
          "On the Profile tab, review your first name, last name, email, and phone number."
      },
      {
        bodyKey: "manage-profile-sop-view-2",
        bodyFallback:
          "Your role (for example, Company Admin or Store Manager) appears under your name. This shows what you can access in the system."
      },
      {
        bodyKey: "manage-profile-sop-view-3",
        bodyFallback:
          "Account status shows whether your account is active. If it shows N/A or looks wrong, contact your company admin."
      },
      {
        bodyKey: "manage-profile-sop-view-4",
        bodyFallback:
          "Use the Logout button when you want to sign out on a shared device."
      }
    ]
  },
  {
    id: "edit-profile",
    titleKey: "manage-profile-sop-edit-title",
    titleFallback: "Edit your profile",
    introKey: "manage-profile-sop-edit-intro",
    introFallback:
      "Update your profile when your contact details change or when you want a new photo for your account.",
    steps: [
      {
        bodyKey: "manage-profile-sop-edit-1",
        bodyFallback:
          "On the Profile tab, click the purple Edit your profile button."
      },
      {
        bodyKey: "manage-profile-sop-edit-2",
        bodyFallback:
          "A form will open. Click the camera icon on the photo circle to upload a new picture. This is optional.",
        imageId: "edit-profile"
      },
      {
        bodyKey: "manage-profile-sop-edit-3",
        bodyFallback: "Update your first name and last name if needed."
      },
      {
        bodyKey: "manage-profile-sop-edit-4",
        bodyFallback: "Choose your country code, then enter your phone number."
      },
      {
        bodyKey: "manage-profile-sop-edit-5",
        bodyFallback:
          "Click Save Changes to keep your updates, or Cancel to close the form without saving."
      }
    ]
  },
  {
    id: "change-password",
    titleKey: "manage-profile-sop-password-title",
    titleFallback: "Change your password",
    introKey: "manage-profile-sop-password-intro",
    introFallback:
      "Change your password regularly or right away if you think someone else knows it. Pick a strong password you do not use on other websites.",
    steps: [
      {
        bodyKey: "manage-profile-sop-password-1",
        bodyFallback: "On the Profile page, tap the Password tab."
      },
      {
        bodyKey: "manage-profile-sop-password-2",
        bodyFallback:
          "Enter your current password, then type your new password twice to confirm it.",
        imageId: "change-password"
      },
      {
        bodyKey: "manage-profile-sop-password-3",
        bodyFallback:
          "Use the eye icon beside each field if you want to check what you typed."
      },
      {
        bodyKey: "manage-profile-sop-password-4",
        bodyFallback:
          "Click Change Password to save. Use Reset to clear the fields and start again."
      },
      {
        bodyKey: "manage-profile-sop-password-5",
        bodyFallback:
          "If you forgot your password and cannot sign in, use Forgot password on the login page instead."
      }
    ]
  }
];
